import axios from 'axios'
import qs from 'qs'
export const templateService = ({
  createTemplate (token, formObj) {
    return axios.post('/api/EmailTemplate/Create', formObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateTemplate (token, formObj) {
    return axios.put('/api/EmailTemplate/Update', formObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateTopic (token, topicObj) {
    var stringifiedObj = qs.stringify(topicObj)
    return axios.put('/api/topic/update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteTemplate (token, templateId) {
    return axios.delete('/api/EmailTemplate/Delete?emailTemplateId=' + templateId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/template-service.js